// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"953275ee","178":"e303c449","291":"8efa4018","379":"9d8c17e1","787":"a4b45000","842":"906df0bc"}[chunkId] + ".chunk.js";
};